import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Button,
  Card,
  CardContent
} from "@mui/material";

import RateTable from "./RateTable";
import RateFormDialog from "./RateFormDialog";

import {
  getBillingRates,
  deleteBillingRate
} from "../../api/billingApi";

export default function RateMaintenance() {

  const [rates, setRates] = useState([]);
  const [openForm, setOpenForm] = useState(false);

  /* =========================
     LOAD RATES
  ========================= */

  const loadRates = async () => {

    try {

      const res = await getBillingRates();
      setRates(res.data);

    } catch (err) {

      console.error("Rate load error", err);

    }

  };

  /* =========================
     DELETE RATE
  ========================= */

  const handleDelete = async (id) => {

    try {

      await deleteBillingRate(id);
      loadRates();

    } catch (err) {

      console.error("Delete rate error", err);

    }

  };

  useEffect(() => {

    loadRates();

  }, []);

  return (

    <Box p={4}>

      <Typography variant="h5" mb={3}>
        Rate Maintenance
      </Typography>

      <Card>

        <CardContent>

          <Button
            variant="contained"
            sx={{ mb: 2 }}
            onClick={() => setOpenForm(true)}
          >
            Add Rate
          </Button>

          <RateTable
            rates={rates}
            onDelete={handleDelete}
          />

        </CardContent>

      </Card>

      <RateFormDialog
        open={openForm}
        onClose={() => {
          setOpenForm(false);
          loadRates();
        }}
      />

    </Box>

  );

}